<ng-container>
    <div class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
        <ng-container *ngIf="fieldOperators?.length > 0" id="fieldOperatorContainer">
            <div class="scope-criteria ">
                <div class="field">
                    <label soho-label for="fieldOperator">{{ 'FieldPicker_FieldOperatorLabel' | translate }}</label>
                    <select
                            id="fieldOperator"
                            soho-dropdown
                            noSearch
                            name="fieldOperator"
                            data-automation-id="lm-field-picker-field-operator"
                            (change)="onOperatorChange('field')"
                            [(ngModel)]="operatorInfo.fieldOperator"
                            [ngClass]="'dropdown-md'">
                        <ng-container *ngFor="let option of fieldOperators">
                            <optgroup *ngIf="option.children" [label]="option.label">
                                <option *ngFor="let child of option.children"
                                        [value]="child.value">{{child.label}}</option>
                            </optgroup>
                            <option *ngIf="!option.children" [value]="option.value">{{option.label}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>
        </ng-container>
        <div *ngIf="typeOperators?.length > 0"  class="scope-criteria ">
            <div class="field">
                <label soho-label for="typeOperator">{{ 'FieldPicker_TypeOperatorLabel' | translate }}</label>
                <select
                        id="typeOperator"
                        soho-dropdown
                        noSearch
                        name="typeOperator"
                        data-automation-id="lm-field-picker-type-operator"
                        (change)="onOperatorChange('type')"
                        [ngClass]="'dropdown-md'"
                        [(ngModel)]="operatorInfo.typeOperatorInfo.typeOperator">
                    <ng-container *ngFor="let option of typeOperators">
                        <optgroup *ngIf="option.children" [label]="option.label">
                            <option *ngFor="let child of option.children"
                                    [value]="child.value">{{child.label}}</option>
                        </optgroup>
                        <option *ngIf="!option.children" [value]="option.value">{{option.label}}</option>
                    </ng-container>
                </select>
            </div>
        </div>
        <div class="scope-criteria ">
            <ng-container *ngIf="operatorInfo?.typeOperatorInfo?.typeOperator === 'using'" id="javaFormatContainer">
                <div class="field">
                    <label [required]="true" soho-label for="javaFormat">{{ 'FieldPicker_FormatLabel' | translate }}</label>
                    <input
                            id="javaFormat"
                            data-automation-id="lm-field-picker-type-operator-java-format"
                            (paste)="onOperatorChange()"
                            (keyup)="onOperatorChange()"
                            [(ngModel)]="operatorInfo.typeOperatorInfo.javaFormat"/>
                </div>
            </ng-container>
            <ng-container *ngIf="operatorInfo?.typeOperatorInfo?.typeOperator === 'timestamp format'
                                    || operatorInfo?.typeOperatorInfo?.typeOperator === 'date format'
                                    || operatorInfo?.typeOperatorInfo?.typeOperator === 'anniversary format'
                                    || operatorInfo?.typeOperatorInfo?.typeOperator === 'period format'"
                          id="formatStyleContainer">
                <div class="field">
                    <label soho-label for="fieldOperator">{{ 'FieldPicker_FormatStyleLabel' | translate }}</label>
                    <select
                            id="formatStyle"
                            soho-dropdown
                            noSearch
                            name="formatStyle"
                            data-automation-id="lm-field-picker-type-operator-format-style"
                            (change)="onOperatorChange()"
                            [ngClass]="'dropdown-md'"
                            [(ngModel)]="operatorInfo.typeOperatorInfo.formatStyle">
                        <option *ngFor="let option of formatStyles"
                                [value]="option.value">{{option.label}}</option>
                    </select>
                </div>
            </ng-container>
            <ng-container
                    *ngIf="operatorInfo?.typeOperatorInfo?.typeOperator === 'timestamp format' || operatorInfo?.typeOperatorInfo?.typeOperator === 'date format' || operatorInfo?.typeOperatorInfo?.typeOperator === 'anniversary format'"
                    id="operatorInfo">
                <div class="field field-checkbox">
                    <input
                            id="withDayName"
                            soho-checkbox
                            type="checkbox"
                            class="checkbox"
                            data-automation-id="lm-field-picker-type-operator-with-day-name"
                            (change)="onOperatorChange()"
                            [(ngModel)]="operatorInfo.typeOperatorInfo.withDayName">
                    <label soho-label for="withDayName" [forCheckBox]="true">{{ 'FieldPicker_WithDayNameLabel' | translate }}</label>
                </div>
                <div class="field field-checkbox" style="padding-inline-start: 20px"><!-- TODO css change -->
                    <input
                            id="withShortDayName"
                            soho-checkbox
                            type="checkbox"
                            class="checkbox"
                            disabled="{{!operatorInfo.typeOperatorInfo.withDayName}}"
                            data-automation-id="lm-field-picker-type-operator-with-short-day-name"
                            (change)="onOperatorChange()"
                            [(ngModel)]="operatorInfo.typeOperatorInfo.withShortDayName">
                    <label soho-label for="withShortDayName" [forCheckBox]="true">{{ 'FieldPicker_UseShortNameLabel' | translate }}</label>
                </div>
                <ng-container *ngIf="operatorInfo?.typeOperatorInfo?.typeOperator === 'timestamp format'">
                    <div class="field field-checkbox">
                        <input
                                id="showTimeZone"
                                soho-checkbox
                                type="checkbox"
                                class="checkbox"
                                data-automation-id="lm-field-picker-type-operator-show-time-zone"
                                (change)="onOperatorChange()"
                                [(ngModel)]="operatorInfo.typeOperatorInfo.showTimeZone">
                        <label soho-label for="showTimeZone" [forCheckBox]="true">{{ 'FieldPicker_ShowTimeZoneLabel' | translate }}</label>
                    </div>
                    <div class="field field-checkbox">
                        <input
                                id="hideSeconds"
                                soho-checkbox
                                type="checkbox"
                                class="checkbox"
                                data-automation-id="lm-field-picker-type-operator-hide-seconds"
                                (change)="onOperatorChange()"
                                [(ngModel)]="operatorInfo.typeOperatorInfo.hideSeconds">
                        <label soho-label for="hideSeconds" [forCheckBox]="true">{{ 'FieldPicker_ShowSecondsLabel' | translate }}</label>
                    </div>
                </ng-container>
                <ng-container *ngIf="uiFieldSpec?.lmrkFieldType === 'TIMESTAMP'">
                    <div class="field">
                        <label soho-label for="usingTimeZone">{{ 'FieldPicker_timezone_label' | translate }}</label>
                        <select
                                id="usingTimeZone"
                                soho-dropdown
                                noSearch
                                name="typeOperator"
                                data-automation-id="lm-field-picker-type-operator-using-timezone"
                                (change)="onOperatorChange()"
                                [ngClass]="'dropdown-md'"
                                [(ngModel)]="operatorInfo.typeOperatorInfo.usingTimeZone">
                            <option [value]="'using user time zone'">{{ 'FieldPicker_timezone_default_label' | translate }}</option>
                            <option [value]="'using corporate time zone'">{{ 'FieldPicker_timezone_corporate_label' | translate }}</option>
                            <option [value]="''">{{ 'FieldPicker_timezone_gmt_label' | translate }}</option>
                        </select>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>